import DialogTemplate from './dialog_template.vue'

export default {
    install(Vue: { component: (componentName: string, component: object) => object }) {
        Vue.component('DialogTemplate', DialogTemplate)
    }
}
